export default id => Number.parseInt(id, 10)
